import React, { ComponentProps, PropsWithChildren, forwardRef } from 'react';
import { Button } from '@fiverr-private/button';
import { ChevronDownIcon } from '@fiverr-private/visuals';
import { Stack } from '@fiverr-private/layout_components';
import { useDropdownContext } from '@fiverr-private/dropdown';

interface TriggerButtonProps extends Pick<ComponentProps<typeof Button>, 'onClick'> {}

export const TriggerButton = forwardRef<HTMLButtonElement, PropsWithChildren<TriggerButtonProps>>(
    ({ children, onClick }, ref) => {
        const {
            popoverContext: { open },
        } = useDropdownContext();

        return (
            <Button variant="ghost" onClick={onClick} ref={ref}>
                <Stack gap="1" alignItems="center" color="grey_1200">
                    {children}
                    <Stack transform={open ? 'rotate(180deg)' : 'none'} transition="0.15s ease-in-out">
                        <ChevronDownIcon size="md" />
                    </Stack>
                </Stack>
            </Button>
        );
    }
);

TriggerButton.displayName = 'TriggerButton';
